import { render } from "./CRMWhatsappMediaCatalogDialog.vue?vue&type=template&id=09ed7c6e"
import script from "./CRMWhatsappMediaCatalogDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMediaCatalogDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__